export const membershipColors = {
  ACTIVE: "#01cd74",
  PENDING: "#fbb034",
  DECLINED: "#e4002b",
  INACTIVE: "#818c81",
  CANCELED: "#a68b7d",
  EXPIRED: "#a68b7d",
 "DO NOT RENEW": "#a68b7d",
};
